import {getCookie} from '@optimaxdev/utils';

import {EXTRA_URL_COOKIE_KEY} from 'constants/constants';

type ExtraUrlDataType = {
    utmSource?: string;
    utmMedium?: string;
    utmCampaign?: string;
    utmContent?: string;
    utmTerm?: string;
    referral?: string;
};

/**
 * Method converts extraUrlData cookie to an endpoint format
 * @returns referral and utm data as an object in a correct format for endpoint
 */
export const getExtraUrlData = (): ExtraUrlDataType => {
    const cookieValue = getCookie(EXTRA_URL_COOKIE_KEY);
    if (!cookieValue) return {} as ExtraUrlDataType;

    const {referral, ...extraUrlCookieParsed} = JSON.parse(decodeURIComponent(cookieValue));
    const referralValue = /facebook/i.test(extraUrlCookieParsed?.utm_source)
        ? 'facebook'
        : referral;

    return {
        referral: referralValue,
        utmCampaign: extraUrlCookieParsed?.utm_campaign,
        utmContent: extraUrlCookieParsed?.utm_content,
        utmMedium: extraUrlCookieParsed?.utm_medium,
        utmSource: extraUrlCookieParsed?.utm_source,
        utmTerm: extraUrlCookieParsed?.utm_term,
    };
};
